import { render, staticRenderFns } from "./FirstLevel.vue?vue&type=template&id=f27e1174"
import script from "./FirstLevel.vue?vue&type=script&lang=js"
export * from "./FirstLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports